import React, { useEffect, useState } from 'react'
import AdminLayout from "../UI/Layout/AdminLayout";
import Title from "../UI/Text/Title";
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import { userloginDetails } from '../Utils/AdminAuth';
import Axios from '../../axios/Axios';
import Select from "react-select";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const EncryptionSetting = () => {
    const lStorage = userloginDetails();
    const userId = lStorage.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user?.isAdmin;
    const [checkboxes, setCheckboxes] = useState({
        api: false,
        template: false,
        entity: false,
        report: false,
    });
    const [allUsers, setAllusers] = useState([]);
    const [selecteduser, setSelectedusers] = useState("");
    const [error, setError] = useState({
        errorStatus: false,
        bgColor: '',
        errorMessage: ''
    });
    const [dataList, setDataList] = useState([])
    const [selectedUserid, setSelectedUserid] = useState("")
    const [show, setShow] = useState(false);
    const [deleteID, setDeleteID] = useState("")

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    useEffect(() => {
        usersList();
        RetriveData();
    }, []);

    const usersList = async () => {
        try {
            const response = await fetch(`${HOST_URL}/admin_user_list.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: userId,
                    method: "retrieve_all_user",
                    type: adminType,
                    token: userToken,
                }),
            });

            const result = await response.json();

            if (result.success) {
                const formattedUsers = result.data.map((user) => ({
                    value: user.id,
                    label: user.email,
                }));

                setAllusers(formattedUsers);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };


    const handleChange = (e) => {
        const { name, checked } = e.target;
        setCheckboxes((prevState) => ({
            ...prevState,
            [name]: checked,
        }));
    };

    const SaveChackBoxes = async () => {
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "create_encryption",
            retr_user_id: selecteduser.value,
            api: checkboxes.api ? 1 : 0,
            template: checkboxes.template ? 1 : 0,
            entity: checkboxes.entity ? 1 : 0,
            report: checkboxes.report ? 1 : 0
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/user_encryption`, paramData)
            if (data.success) {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-success',
                    errorMessage: data.message
                });

                setDataList((prevState) => [...prevState,
                {
                    user_id: selecteduser.value,
                    api: checkboxes.api ? 1 : 0,
                    template: checkboxes.template ? 1 : 0,
                    entity: checkboxes.entity ? 1 : 0,
                    report: checkboxes.report ? 1 : 0,
                    created_date: new Date().toISOString().split('T').join(" ")
                }])
                setTimeout(() => {
                    setError({ errorStatus: false })
                }, 5000);
                setSelectedusers("")
                setCheckboxes({
                    api: false,
                    template: false,
                    entity: false,
                    report: false,
                })
            }
            else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger',
                    errorMessage: data.message
                });
                setTimeout(() => {
                    setError({ errorStatus: false })
                }, 5000);
            }
        } catch (error) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger',
                errorMessage: error.message
            });
            setTimeout(() => {
                setError({ errorStatus: false })
            }, 5000);
        }
    }

    const RetriveData = async () => {
        const paramData = {
            user_id: userId,
            token: userToken,
            method: "list_encryption",
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/user_encryption`, paramData)
            if (data.success) {
                setDataList(data.data)
            }
            else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger',
                    errorMessage: data.message
                });
                setTimeout(() => {
                    setError({ errorStatus: false })
                }, 5000);
            }
        } catch (error) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger',
                errorMessage: error.message
            });
            setTimeout(() => {
                setError({ errorStatus: false })
            }, 5000);
        }
    }

    const EditData = (userid, api, template, entity, report) => {
        setCheckboxes({
            api: api === 1 ? true : false,
            template: template === 1 ? true : false,
            entity: entity === 1 ? true : false,
            report: report === 1 ? true : false,
        });
        setSelectedusers({ value: userid, label: allUsers.find(x => x.value === userid)?.label });
        setSelectedUserid(userid)
    }

    const UpdateData = async () => {
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "update_encryption",
            retr_user_id: `${selectedUserid}`,
            api: checkboxes.api ? 1 : 0,
            template: checkboxes.template ? 1 : 0,
            entity: checkboxes.entity ? 1 : 0,
            report: checkboxes.report ? 1 : 0
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/user_encryption`, paramData)
            if (data.success) {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-success',
                    errorMessage: data.message
                });
                setTimeout(() => {
                    setError({ errorStatus: false })
                }, 5000);
                setSelectedusers("")
                setCheckboxes({
                    api: false,
                    template: false,
                    entity: false,
                    report: false,
                })
                setSelectedUserid("")
                RetriveData();
            }
            else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger',
                    errorMessage: data.message
                });
                setTimeout(() => {
                    setError({ errorStatus: false })
                }, 5000);
            }
        } catch (error) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger',
                errorMessage: error.message
            });
            setTimeout(() => {
                setError({ errorStatus: false })
            }, 5000);
        }
    }

    const DeletePopup = (userid) => {
        setShow(true)
        setDeleteID(userid)
    }

    const DeleteData = async () => {
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "delete_encryption",
            retr_user_id: `${deleteID}`
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/user_encryption`, paramData)
            if (data.success) {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-success',
                    errorMessage: data.message
                });
                setTimeout(() => {
                    setError({ errorStatus: false })
                }, 5000);
                setShow(false)
                setDeleteID("")
                RetriveData();
            }
            else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger',
                    errorMessage: data.message
                });
                setTimeout(() => {
                    setError({ errorStatus: false })
                }, 5000);
                setShow(false)
            }
        } catch (error) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger',
                errorMessage: error.message
            });
            setTimeout(() => {
                setError({ errorStatus: false })
            }, 5000);
            setShow(false)
        }
    }

    return (
        <div>
            <AdminLayout>
                {/* <Title isButton={false}>Encryption Setting</Title> */}
                <div className="card card-body shadow-sm">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h6 className="mb-0">
                            {selectedUserid ? 'Edit Encryption Setting' : 'Encryption Setting'}
                        </h6>
                        {selectedUserid && (
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={() => {
                                    setSelectedUserid("");
                                    setSelectedusers("");
                                    setCheckboxes({
                                        api: false,
                                        template: false,
                                        entity: false,
                                        report: false,
                                    });
                                }}
                            >
                                ← Back
                            </button>
                        )}
                    </div>


                    <div>
                        {error.errorStatus && (
                            <div className={`alert ${error.bgColor} d-flex justify-content-between w-100 alert-dismissible fade show`} role="alert">
                                <div>{error.errorMessage}</div>
                                <button
                                    type="button"
                                    className="btn p-0 border-0 bg-transparent"
                                    data-bs-dismiss="alert"
                                    aria-label="Close"
                                >
                                    X
                                </button>

                            </div>
                        )}

                        <form>
                            <div className="row g-3 align-items-center mb-3">
                                <div className="col-md-4">
                                    <label htmlFor="userSelect" className="form-label">Select User</label>
                                    <Select
                                        inputId="userSelect"
                                        onChange={(selectedOption) => setSelectedusers(selectedOption)}
                                        options={allUsers}
                                        value={selecteduser}
                                        isSearchable={true}
                                        placeholder="All Users"
                                        isClearable={true}
                                        styles={customStyles}
                                        isDisabled={!!selectedUserid}
                                    />
                                </div>

                                {['api', 'template', 'entity', 'report'].map((item, idx) => (
                                    <div className="col-md-2 col-6 mt-md-4" key={item}>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`checkbox-${item}`}
                                                name={item}
                                                checked={checkboxes[item]}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" style={{ wordBreak: "keep-all" }} htmlFor={`checkbox-${item}`}>
                                                {item.charAt(0).toUpperCase() + item.slice(1)}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="d-flex justify-content-end mt-4">
                                {selectedUserid ? (
                                    <button type="button" onClick={UpdateData} className="btn btn-info">
                                        Update
                                    </button>
                                ) : (
                                    <button type="button" onClick={SaveChackBoxes} className="btn btn-info">
                                        Save
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>


                {dataList.length > 0 &&
                    <div className='card card-body'>
                        <div className='mb-4'>
                            <h6 className='mb-0'>Encryption Table</h6>
                        </div>
                        <div>
                            <div className="table-responsive">
                                <table className="table table-striped table-bordered table-hover">
                                    <thead className="thead-light">
                                        <tr>
                                            <th style={{ color: "white" }}>Username</th>
                                            <th style={{ color: "white" }}>API</th>
                                            <th style={{ color: "white" }}>Template</th>
                                            <th style={{ color: "white" }}>Entity</th>
                                            <th style={{ color: "white" }}>Report</th>
                                            <th style={{ color: "white" }}>Created Date</th>
                                            <th style={{ color: "white" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataList.map((user, index) => (
                                            <tr key={user.user_id}>
                                                <td>{allUsers.find(x => x.value === user.user_id)?.label}</td>
                                                <td>{user.api === 1 ? <span>YES</span> : <span>NO</span>}</td>
                                                <td>{user.template === 1 ? <span>YES</span> : <span>NO</span>}</td>
                                                <td>{user.entity === 1 ? <span>YES</span> : <span>NO</span>}</td>
                                                <td>{user.report === 1 ? <span>YES</span> : <span>NO</span>}</td>
                                                <td>{user.created_date}</td>
                                                <td>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                        <FontAwesomeIcon
                                                            onClick={() => EditData(user.user_id, user.api, user.template, user.entity, user.report)}
                                                            icon={faEdit}
                                                        />
                                                        <FontAwesomeIcon onClick={() => DeletePopup(user.user_id)} icon={faTrashAlt} />
                                                    </div>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}

                {show && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                    >
                        <div className="bg-white p-4 rounded shadow" style={{ maxWidth: '400px', width: '90%' }}>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">Custom Popup</h5>
                                <span onClick={() => setShow(false)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                                    ×
                                </span>
                            </div>
                            <p>Are You Sure you Want to Delete</p>
                            <div className="text-end">
                                <button className="btn btn-secondary me-2" onClick={() => setShow(false)}>
                                    Cancel
                                </button>
                                <button className="btn btn-primary" onClick={DeleteData}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </AdminLayout>
        </div>
    )
}

export default EncryptionSetting
